import axios from "axios";
import { IAzMapsClientId } from "pages/Explore/types";
import { useQuery } from "react-query";
import { API_VERSION, CONFIG_URL } from "utils/constants";

export const useAzMapsClientId = () => {
  // We set the staleTime and cacheTime to 24 hours to prevent the client ID from being
  // refetched on every render. This value doesn't change for the lifetime of the deployment.
  // We have been seeing issues with the client ID being refetched causing blank maps.
  return useQuery("azMapsClientId", getAzMapsClientId, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    cacheTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};

const getAzMapsClientId = async (): Promise<string> => {
  const resp = await axios.get<IAzMapsClientId>(`${CONFIG_URL}/map/id`, {
    params: { "api-version": API_VERSION },
  });
  return resp.data.client_id;
};
